import React, { useState } from 'react';
import SEO from '@/components/foundations/seo';

import ModalContent from '@/components/objects/bownow';

// page comp
import KeyVisual from '@/components/pages/prototyping/keyVisual';
import Problem from '@/components/pages/prototyping/problem';
import Solution from '@/components/pages/prototyping/solution';
import Service from '@/components/pages/prototyping/service';
import Output from '@/components/pages/prototyping/output';
import Plan from '@/components/pages/prototyping/plan';
import CaseStudies from '@/components/pages/prototyping/caseStudies';
import WhoWeAre from '@/components/pages/prototyping/whoWeAre';
import Conversion from '@/components/pages/prototyping/conversion';
import Modal from '@/components/foundations/modal';

const IndexPage: React.FC<{ routeRef: React.RefObject<HTMLDivElement> }> = ({ routeRef }) => {
  const [active, setActive] = useState(false);
  // const [popup, setPopup] = useState<null | React.FC>(null);
  const [isScrolled, setIsScrolled] = useState(false);

  const modalHandler = (): void => {
    // setPopup(ModalContent);
    setActive(true);
  };

  return (
    <>
      <SEO
        title='PIVOTのプロトタイピング'
        description='プロジェクトリスクをコントロール！"実現したい価値”から具現化する、ローコスト＆スピーディーなプロダクト開発についてご説明します。'
        ogImage={`https://${process.env.GATSBY_DOMAIN}${process.env.GATSBY_PATH}/assets/img/prototyping/ogp.png`}
        pageName='prototyping'
      />
      <KeyVisual modal={modalHandler} isScrolled={isScrolled} />
      <Problem setScroll={setIsScrolled} />
      <Solution />
      <Service />
      <Output />
      <Plan />
      <CaseStudies />
      <WhoWeAre />
      <Conversion modal={modalHandler} />
      <Modal isOpen={active} setter={setActive} routeRef={routeRef} isStatic>
        <ModalContent sid="sid_fa4ccee653fece8ce314"/>
      </Modal>
    </>
  );
};

export default IndexPage;
